import React, { Component, Suspense, lazy } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import FakeInput from './fakeInput';

const Search = lazy(() => import('./searchFunction/index'));

const Holder = styled.div`
  height: 0;
  width: 100%;
  position: relative;
  z-index: 1;
`;

export default class HeaderSearch extends Component {
  static propTypes = {
    fetchUserInfo: PropTypes.func,
    loginStatus: PropTypes.string,
    loginInfo: PropTypes.object,
    initialSuggestion: PropTypes.string,
    initialLocation: PropTypes.string,
    trackEvent: PropTypes.func,
    SearchBar: PropTypes.func,
  };

  static defaultProps = {
    SearchBar: () => false,
  };

  state = {
    isOpen: false,
  };

  /* used for detecting clicks outside search bar component - shearch should close (revert to
  grey bar) if a user clicks anywhere outside the search bar
   */

  // new in react 16, stops errors in the header crashing the site. If there is an issue, just close the header
  componentDidCatch(error) {
    this.setState({ isOpen: false });
    if (typeof newrelic !== 'undefined') {
      window.newrelic.noticeError(error);
    }
  }

  openSearch = () => {
    this.setState({ isOpen: true });
    const { trackEvent } = this.props;
    if (typeof trackEvent === 'function') {
      trackEvent('Header', 'Open Search Bar');
    }
  };

  close = () => {
    this.setState({ isOpen: false });
  };

  render() {
    const { isOpen } = this.state;

    const { initialSuggestion, initialLocation, trackEvent } = this.props;
    const FakeInputData = {
      openSearch: () => this.openSearch(),
      initialSuggestion,
      initialLocation,
    };
    const SearchData = {
      openSearch: () => this.openSearch(),
      initialSuggestion,
      initialLocation,
      trackEvent,
      closeSearch: () => this.close(),
    };
    return (
      <Holder>
        {isOpen ? (
          <Suspense fallback={<FakeInput {...FakeInputData} />}>
            <Search {...SearchData} />
          </Suspense>
        ) : (
          <FakeInput {...FakeInputData} />
        )}
      </Holder>
    );
  }
}
